import wheel from '../../selectors/props/wheel';
import types from './types';

const InitialState = {
    loaded: false,
    opened: false,
    wheel: {
        status: 'none',
        rotate: 0,
        button: false
    },
    sectors: [],
    rewards: [],
    prize: null,
    prize_button: false,
    timeout: 0
}

export default (state = InitialState, {type, payload}) => {
    switch(type) {
        case types.opened:
            return {
                ...state,
                opened: !state.opened
            }
        case types.togglePrizeButton:
            return {
                ...state,
                prize_button: !state.prize_button
            }
        case types.prize:
            return {
                ...state,
                prize: payload
            }
        case types.timeout:
            return {
                ...state,
                timeout: payload
            }
        case types.wheel.toggleButton:
            return {
                ...state,
                wheel: {
                    ...state.wheel,
                    button: !state.wheel.button
                }
            }
        case types.wheel.update:
            return {
                ...state,
                wheel: {
                    ...state.wheel,
                    ...payload
                }
            }
        case types.loaded:
            return {
                ...state,
                loaded: true,
                opened: payload.timeout <= Date.now(),
                sectors: payload.sectors,
                rewards: payload.rewards,
                prize: payload.prize,
                wheel: {
                    ...state.wheel,
                    rotate: payload.rotate
                },
                timeout: payload.timeout
            }
        default:
            return state;
    }
}